<template>
  <v-btn
    v-model="disabled"
    :class="$attrs.class ? $attrs.class : btnclass"
    @click="$attrs.click"
    :color="$attrs.color ? $attrs.color : color"
    :disabled="disabled"
    >{{ $attrs.label ? $attrs.label : label }}</v-btn
  >
</template>
<script>
export default {
  name: "SubmitButton",
  props: {
    isDisabled: Boolean,
    default() {
      return true;
    },
  },
  data() {
    return {
      label: "Submit",
      color: "success",
      btnclass: "mr-4",
    };
  },
  methods: {
    onClickButton(event) {
      this.$emit("clicked", event);
    },
  },
  computed: {
    disabled: {
      get() {
        return this.isDisabled;
      },
      set(value) {
        this.$emit("update:isDisabled", value);
      },
    },
  },
};
</script>

<style scoped></style>
